var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChargeSessions(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.64157 4.50552L8.00026 5.31582H9.03363H12.0069L3.38962 13.5382L4.66011 8.45623L4.81543 7.83496H4.17504H1.73325L5.87159 0.6875H11.6633L8.64157 4.50552ZM4.16284 11.2546L3.74375 12.9296L4.99303 11.7377L10.6145 6.37466L11.5178 5.51289H10.2694H7.59349L10.614 1.69479L11.255 0.88457H10.2219H6.27387H5.98563L5.84118 1.134L2.50837 6.88908L2.07371 7.63965H2.94105H5.06733L4.16284 11.2546Z",
    stroke: "#0D0D0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChargeSessions);
export default __webpack_public_path__ + "static/media/charge-sessions.289f8e65eb6d4b1e86cdd5f39b4f7aaf.svg";
export { ForwardRef as ReactComponent };